import Flex from 'src/components/Layout/Flex/Flex'
import { LabelWrapperProps, RadioGroupWrapperProps } from './types'
import styled, { css } from 'styled-components'

export const RadioGroupWrapper = styled('div')<RadioGroupWrapperProps>`
  min-height: ${props => props.minHeight || '92px'};
  min-width: 100px;
  margin: ${props => props.margin || '0px'};
  ${props =>
    props.gridArea &&
    css`
      grid-area: ${props.gridArea};
  `}

  ${props =>
    props.flexProperties &&
    css`
      display: flex;
      justify-content: ${props.flexProperties.justifyContent || 'center'};  
      align-items: ${props.flexProperties.alignItems || 'center'};  
  `}

  ${props => props.responsive && css`
      @media (max-width: ${props.theme.breakpoints[`${1550}`]}) {
        ${Flex}{
          flex-direction: ${props.flexProperties.flexDirection || 'column'};
          justify-content: ${props.flexProperties.justifyContent || 'center'};  
          align-items: ${props.flexProperties.alignItems || 'center'};  
        }
      }
    `
}

  


`

export const LabelWrapper = styled('div')<LabelWrapperProps>`
  width: 100%;
  margin-bottom: ${props => props.marginBottom || '16px'};
`
